// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const arctovish: PokeData = {
  "id": 883,
  "name": "arctovish",
  "height": 20,
  "weight": 1750,
  "base_experience": 177,
  "types": [
    PokeType.WATER,
    PokeType.ICE
  ],
  "api_moves": [
    "bite",
    "water-gun",
    "blizzard",
    "super-fang",
    "powder-snow",
    "protect",
    "icy-wind",
    "crunch",
    "ancient-power",
    "icicle-crash",
    "freeze-dry",
    "aurora-veil",
    "fishious-rend"
  ],
  "moves": [
    "bite",
    "blizzard",
    "protect",
    "crunch",
    "ancient-power",
    "aurora-veil",
    "ice-shard",
    "hydro-pump",
    "avalanche",
    "aqua-cutter",
    "bubble-beam",
    "ice-wave",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 464,
    "item": null,
    "species": [
      {
        "name": "arctovish",
        "order": 883,
        "types": [
          PokeType.WATER,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 156,
    "speed": 93,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
